import { render, staticRenderFns } from "./FormType7.vue?vue&type=template&id=10ab4c34&"
import script from "./FormType7.vue?vue&type=script&lang=js&"
export * from "./FormType7.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports